import React, { useState } from "react";
import { useAuth } from "../App/useAuth";
import { InputName } from "./Inputs/Input_Name";
import { Box, Button, Stack } from "@mui/material";
import { FtchPlusError, ftchPlus, postOptions } from "../App/Account_urls";
import { API_Client } from "../App/api";
import { CollapseStateLabel } from "../App/CollapseButtons";

const AdminCopyScenario = ({ clientJson, onError }) => {
    const { admin_r } = useAuth();
    const [admin] = useState(admin_r.current)
    const [adminClone, setAdminClone] = useState(false)
    const [form, setForm] = useState({
        SubUuid: "",
        ClientUuid: "",
        ScenarioUuid: "",
    })

    const onChange = (e) => {
        let form = {
            ...form,
            [e.target.name]: e.target.value,
        };
    }

    const onSubmit = async () => {

        console.log("clone: " + clientJson.uuid);
        console.log(form);
        let url = API_Client + clientJson.uuid + "/scenario/new/clone";
        let req = postOptions
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((json) => {
                console.log("did clone ");
            })
            .catch((error) => {
                console.log(error.message);
                onError(error.message)
                FtchPlusError(error)
            });


    }

    return (
        (false && admin &&
            <Stack direction="row" spacing={2}>
                <Box sx={{ display: "flex" }}>
                    <CollapseStateLabel
                        add={adminClone}
                        onClick={(e) => setAdminClone(!adminClone)}
                        label="Admin Clone"
                    />
                </Box>
                {adminClone && (
                    <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
                        <Stack spacing={2}>
                            <Stack direction="row" spacing={2}>
                                <InputName
                                    label="Sub"
                                    value={form.SubUuid}
                                    name="SubUuid"
                                    onChange={onChange}
                                />
                                <InputName
                                    label="Sub"
                                    value={form.ClientUuid}
                                    name="ClientUuid"
                                    onChange={onChange}
                                />
                                <InputName
                                    label="Scenario"
                                    value={form.ScenarioUuid}
                                    name="ScenarioUuid"
                                    onChange={onChange}
                                />

                                <Button
                                    onSubmit={onSubmit}
                                    variant="contained"
                                >
                                    Admin Clone
                                </Button>
                            </Stack >
                        </Stack>
                    </Box >
                )}
            </Stack>
        ))
}


export default AdminCopyScenario;
